import apiClient from "@/lib/api-client";

/**
 * ActivationCodeService - Quản lý mã kích hoạt
 * 
 * API endpoints:
 * - GET activation-codes - Danh sách mã
 * - POST activation-codes/batch - Tạo lô mã
 * - PATCH activation-codes/{id} - Cập nhật mã
 * - DELETE activation-codes/{id} - Xóa mã
 * - POST activation-codes/export - Xuất mã
 */
export class ActivationCodeService {
  // Lấy danh sách mã kích hoạt với filter
  static async getCodes(params = {}) {
    const searchParams = new URLSearchParams();
    if (params.q) searchParams.append('q', params.q);
    if (params.status) searchParams.append('status', params.status);
    if (params.sku) searchParams.append('sku', params.sku);
    if (params.book_id) searchParams.append('book_id', params.book_id);
    if (params.date_from) searchParams.append('date_from', params.date_from);
    if (params.date_to) searchParams.append('date_to', params.date_to);
    if (params.page) searchParams.append('page', params.page);
    if (params.per_page) searchParams.append('per_page', params.per_page);

    const queryString = searchParams.toString();
    const url = queryString ? `activation-codes?${queryString}` : 'activation-codes';
    
    const response = await apiClient.get(url);
    return response.data;
  }

  // Tạo lô mã kích hoạt
  static async createBatch(data) {
    const response = await apiClient.post('activation-codes/batch', data);
    return response.data;
  }

  // Lấy chi tiết mã kích hoạt
  static async getCode(codeId) {
    const response = await apiClient.get(`activation-codes/${codeId}`);
    return response.data;
  }

  // Cập nhật trạng thái mã (vô hiệu hóa/kích hoạt lại)
  static async updateCode(codeId, data) {
    const response = await apiClient.patch(`activation-codes/${codeId}`, data);
    return response.data;
  }

  // Xóa mã kích hoạt
  static async deleteCode(codeId) {
    const response = await apiClient.delete(`activation-codes/${codeId}`);
    return response.data;
  }

  // Thu hồi/hủy nhiều mã cùng lúc
  static async revokeCodes(codeIds) {
    const response = await apiClient.post('activation-codes/revoke', { 
      code_ids: codeIds 
    });
    return response.data;
  }

  // Xuất mã ra file (CSV/PDF)
  static async exportCodes(params) {
    const response = await apiClient.post('activation-codes/export', params, {
      responseType: 'blob'
    });
    return response;
  }

  // Thống kê mã kích hoạt
  static async getStatistics(params = {}) {
    const searchParams = new URLSearchParams();
    if (params.book_id) searchParams.append('book_id', params.book_id);
    if (params.sku) searchParams.append('sku', params.sku);
    if (params.date_from) searchParams.append('date_from', params.date_from);
    if (params.date_to) searchParams.append('date_to', params.date_to);

    const queryString = searchParams.toString();
    const url = queryString ? `activation-codes/statistics?${queryString}` : 'activation-codes/statistics';
    
    const response = await apiClient.get(url);
    return response.data;
  }

  // Lấy danh sách lô mã kích hoạt với filter
  static async getBatches(params = {}) {
    const searchParams = new URLSearchParams();
    if (params.q) searchParams.append('q', params.q);
    if (params.sku) searchParams.append('sku', params.sku);
    if (params.book_id) searchParams.append('book_id', params.book_id);
    if (params.date_from) searchParams.append('date_from', params.date_from);
    if (params.date_to) searchParams.append('date_to', params.date_to);
    if (params.page) searchParams.append('page', params.page);
    if (params.per_page) searchParams.append('per_page', params.per_page);

    const queryString = searchParams.toString();
    const url = queryString ? `activation-codes/batches?${queryString}` : 'activation-codes/batches';
    
    const response = await apiClient.get(url);
    return response.data;
  }

  // Lấy chi tiết lô mã kích hoạt
  static async getBatch(batchId) {
    const response = await apiClient.get(`activation-codes/batches/${batchId}`);
    return response.data;
  }

  // Lấy danh sách mã kích hoạt theo lô
  static async getCodesByBatch(batchId, params = {}) {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.append('page', params.page);
    if (params.per_page) searchParams.append('per_page', params.per_page);

    const queryString = searchParams.toString();
    const url = queryString ? `activation-codes/batch/${batchId}/codes?${queryString}` : `activation-codes/batch/${batchId}/codes`;
    
    const response = await apiClient.get(url);
    return response.data;
  }
}
